module.exports = __webpack_public_path__ + "media/coeur.09725743.webm";